import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { applyTheme, storedTheme } from "./app/theme";
import "./index.css";

applyTheme(storedTheme()); // before the first paint: no flash of the other theme

const root = document.getElementById("root");
if (!root) throw new Error("no #root element");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
